import { render, staticRenderFns } from "./AddPassport.vue?vue&type=template&id=ebbe2f60&"
import script from "./AddPassport.vue?vue&type=script&lang=js&"
export * from "./AddPassport.vue?vue&type=script&lang=js&"
import style0 from "./AddPassport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports